// Unificado: usar la instancia central de API
import api from '@/services/api'

class ConfiguracionService {
  // Configuración de Empresa
  async getEmpresaConfig() {
    try {
      const response = await api.get('/configuracion/empresa')
      return response.data
    } catch (error) {
      console.error('Error al obtener configuración de empresa:', error)
      throw error
    }
  }

  async updateEmpresaConfig(data) {
    try {
      const response = await api.put('/configuracion/empresa', data)
      return response.data
    } catch (error) {
      console.error('Error al actualizar configuración de empresa:', error)
      throw error
    }
  }

  async exportarConfiguracion() {
    try {
      const response = await api.get('/configuracion/empresa/export', {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      console.error('Error al exportar configuración:', error)
      throw error
    }
  }

  // Gestión de Usuarios
  async getUsuarios(params = {}) {
    try {
      const response = await api.get('/configuracion/usuarios', { params })
      return response.data
    } catch (error) {
      console.error('Error al obtener usuarios:', error)
      throw error
    }
  }

  async getUsuariosActivos(params = {}) {
    try {
      const response = await api.get('/configuracion/usuarios/activos', { params })
      return response.data
    } catch (error) {
      console.error('Error al obtener usuarios activos:', error)
      throw error
    }
  }

  async createUsuario(data) {
    try {
      const response = await api.post('/configuracion/usuarios', data)
      return response.data
    } catch (error) {
      console.error('Error al crear usuario:', error)
      throw error
    }
  }

  async updateUsuario(id, data) {
    try {
      const response = await api.put(`/configuracion/usuarios/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Error al actualizar usuario:', error)
      throw error
    }
  }

  async deleteUsuario(id) {
    try {
      const response = await api.delete(`/configuracion/usuarios/${id}`)
      return response.data
    } catch (error) {
      console.error('Error al eliminar usuario:', error)
      throw error
    }
  }

  async exportarUsuarios() {
    try {
      const response = await api.get('/configuracion/usuarios/export', {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      console.error('Error al exportar usuarios:', error)
      throw error
    }
  }

  // Parámetros del Sistema
  async getParametros() {
    try {
      const response = await api.get('/configuracion/parametros')
      return response.data
    } catch (error) {
      console.error('Error al obtener parámetros:', error)
      throw error
    }
  }

  async updateParametros(data) {
    try {
      const response = await api.put('/configuracion/parametros', data)
      return response.data
    } catch (error) {
      console.error('Error al actualizar parámetros:', error)
      throw error
    }
  }

  async probarEmail(config) {
    try {
      const response = await api.post('/configuracion/email/test', config)
      return response.data
    } catch (error) {
      console.error('Error al probar email:', error)
      throw error
    }
  }

  async limpiarCache() {
    try {
      const response = await api.post('/configuracion/cache/clear')
      return response.data
    } catch (error) {
      console.error('Error al limpiar cache:', error)
      throw error
    }
  }

  async exportarParametros() {
    try {
      const response = await api.get('/configuracion/parametros/export', {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      console.error('Error al exportar parámetros:', error)
      throw error
    }
  }

  async verificarActualizaciones() {
    try {
      const response = await api.get('/configuracion/updates/check')
      return response.data
    } catch (error) {
      console.error('Error al verificar actualizaciones:', error)
      throw error
    }
  }

  // Validaciones
  validateEmpresaConfig(data) {
    const errors = {}
    
    // Validar campos requeridos
    if (!data.business_name || data.business_name.trim() === '') {
      errors.business_name = 'La razón social es requerida'
    }
    
    if (!data.trade_name || data.trade_name.trim() === '') {
      errors.trade_name = 'El nombre comercial es requerido'
    }
    
    if (!data.ruc || data.ruc.trim() === '') {
      errors.ruc = 'El RUC es requerido'
    } else if (!/^[0-9]{13}$/.test(data.ruc)) {
      errors.ruc = 'El RUC debe tener 13 dígitos'
    }
    
    if (!data.email || data.email.trim() === '') {
      errors.email = 'El email es requerido'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = 'El email no tiene un formato válido'
    }
    
    if (!data.address || data.address.trim() === '') {
      errors.address = 'La dirección es requerida'
    }
    
    if (!data.phone || data.phone.trim() === '') {
      errors.phone = 'El teléfono es requerido'
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    }
  }

  validateUsuario(data, isEdit = false) {
    const errors = {}
    
    if (!data.full_name || data.full_name.trim() === '') {
      errors.full_name = 'El nombre completo es requerido'
    }
    
    if (!data.username || data.username.trim() === '') {
      errors.username = 'El nombre de usuario es requerido'
    } else if (data.username.length < 3) {
      errors.username = 'El nombre de usuario debe tener al menos 3 caracteres'
    }
    
    if (!data.email || data.email.trim() === '') {
      errors.email = 'El email es requerido'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = 'El email no tiene un formato válido'
    }
    
    if (!data.role || data.role.trim() === '') {
      errors.role = 'El rol es requerido'
    }
    
    // Validar contraseña solo en creación
    if (!isEdit) {
      if (!data.password || data.password.trim() === '') {
        errors.password = 'La contraseña es requerida'
      } else if (data.password.length < 6) {
        errors.password = 'La contraseña debe tener al menos 6 caracteres'
      }
      
      if (!data.password_confirmation || data.password_confirmation.trim() === '') {
        errors.password_confirmation = 'La confirmación de contraseña es requerida'
      } else if (data.password !== data.password_confirmation) {
        errors.password_confirmation = 'Las contraseñas no coinciden'
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    }
  }

  validateParametros(data) {
    const errors = {}
    
    if (!data.system_name || data.system_name.trim() === '') {
      errors.system_name = 'El nombre del sistema es requerido'
    }
    
    if (!data.timezone || data.timezone.trim() === '') {
      errors.timezone = 'La zona horaria es requerida'
    }
    
    if (data.invoice_sequence < 1) {
      errors.invoice_sequence = 'El secuencial debe ser mayor a 0'
    }
    
    if (data.default_tax_rate < 0 || data.default_tax_rate > 100) {
      errors.default_tax_rate = 'El IVA debe estar entre 0 y 100'
    }
    
    if (data.session_timeout < 5 || data.session_timeout > 1440) {
      errors.session_timeout = 'El tiempo de sesión debe estar entre 5 y 1440 minutos'
    }
    
    if (data.max_login_attempts < 3 || data.max_login_attempts > 10) {
      errors.max_login_attempts = 'Los intentos de login deben estar entre 3 y 10'
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    }
  }

  // Utilidades
  formatearRol(rol) {
    const roles = {
      admin: 'Administrador',
      manager: 'Gerente', 
      user: 'Usuario'
    }
    return roles[rol] || rol
  }

  formatearEstado(activo) {
    return activo ? 'Activo' : 'Inactivo'
  }

  formatearFecha(fecha) {
    if (!fecha) return '-'
    
    return new Date(fecha).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  // Configuración de roles y permisos por defecto
  getPermisosDefault(rol) {
    const permisosPorRol = {
      admin: [
        'usuarios_view', 'usuarios_create', 'usuarios_edit', 'usuarios_delete',
        'clientes_view', 'clientes_create', 'clientes_edit', 'clientes_delete',
        'productos_view', 'productos_create', 'productos_edit', 'productos_delete',
        'facturacion_view', 'facturacion_create', 'facturacion_edit', 'facturacion_delete',
        'reportes_view', 'reportes_export',
        'empresas_view', 'empresas_edit'
      ],
      manager: [
        'clientes_view', 'clientes_create', 'clientes_edit',
        'productos_view', 'productos_create', 'productos_edit',
        'facturacion_view', 'facturacion_create', 'facturacion_edit',
        'reportes_view', 'reportes_export',
        'empresas_view', 'empresas_edit'
      ],
      user: [
        'clientes_view', 'clientes_create',
        'productos_view',
        'facturacion_view', 'facturacion_create'
      ]
    }
    
    return permisosPorRol[rol] || []
  }
}

export default new ConfiguracionService()
